module.exports = __webpack_public_path__ + "assets/img/043.a7b14320.png";